<template>
  <div>
    <!-- <vue-apex-charts type="bar" :options="options" :series="series"/> -->
    <div id="BillPayableHstoricChart"></div>
  </div>
</template>

<script>

import VueApexCharts from "vue-apexcharts";
import moment from "moment"

export default {
  components : { VueApexCharts },
  props : {
    data : {
      default() {
        return []
      }
    },
  },

  computed : {
    categories() {
      return this.data.map((row) => { return row.ordered_at })
    },

    values() {
      return this.data.map((row) => { return row.sum_net_total })
    },

     valuespayed() {
      return this.data.map((row) => { return row.sum_payed_value })
    },

    // options () {
    //   return {
    //     chart: {
    //       id: "vuechart-example"
    //     },
    //     xaxis: {
    //       categories: this.categories
    //     }
    //   }
    // }
  },

  watch : {
    data(val) {
      this.options.series[0].data = this.values
      this.options.series[1].data = this.valuespayed
      this.options.xaxis.categories = this.categories

      var chart = new ApexCharts(document.querySelector("#BillPayableHstoricChart"), this.options);

      chart.render();
    }
  },

  data: function() {
    return {
      options: {
        //tooltip: {
          // x: {
          //   formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
          //     return '$'+value
          //   }
          // }
        //},
        chart: {
          type: 'bar'
        },
        series: [{
          name: 'A pagar',
          data: [],
          labels : {

            formatter: function(value) {
              return '$'+value
            }
          }
        },

        {
          name: 'Pago',
          data: [],
          labels : {

            formatter: function(value) {
              return '$'+value
            }
          }
        },


        ],


        xaxis: {
          categories: [],
          labels: {
            formatter: function (value) {
              return moment(value, 'YYYY-MM').format('MM/YYYY');
            }
          },
          axisTicks : {
            show : false
          },
          lines: {
            show: false
          }
        },
        yaxis : {
          labels: {
            formatter : function (val) {
              return Number(val).toLocaleString('PT-br')
            }
          },
          lines: {
            show: false
          }
        },
        plotOptions: {
          // bar: {
          //   horizontal: false,
          // },
          dataLabels: {
            enabled : true,
            position: 'bottom',
            formatter :  function(val) {
              return '$' + val
            },
          }
        },
      }
    }
  }
};
</script>

<style>
</style>
